"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogLevel_1 = require("../logger/LogLevel");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");
/**
 * A task that wraps another task and ensures it is run only once,
 * regardless of how many times `run` is called.
 *
 * This allows you to implement a kind of barrier synchronization.
 */


var OnceTask = /*#__PURE__*/function () {
  function OnceTask(logger, task, dependencies) {
    _classCallCheck(this, OnceTask);

    this.logger = logger;
    this.task = task;
    this.dependencies = dependencies; // Whether we have canceled.

    this.canceled = false;
  }

  _createClass(OnceTask, [{
    key: "name",
    value: function name() {
      return "".concat(this.task.name(), " (once)");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this = this;

      // We want to preserve one interesting property: the deepest dependency that hasn't
      // already finished or been canceled is the first to be canceled, and its failure
      // will propagate back up the promise chain.
      //
      // We can't just cancel ourselves with cancelPromise -- we will cut off the rest of
      // the tree. Nor can we necessarily do it on the same event loop tick, because the
      // cancelation might be subtly async.
      //
      // Instead, we immediately cancel each dependency, and then we cancel the current
      // task (if it's running), and then we cancel via our promise escape hatch if needed.

      /* istanbul ignore if */
      if (this.canceled) {
        return;
      }

      if (this.dependencies) {
        var _iterator = _createForOfIteratorHelper(this.dependencies),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var dep = _step.value;
            dep.cancel();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Do this on the next tick so that our canceled dependencies cascade.


      this.logger.info("Canceling ".concat(this.name()));
      AsyncScheduler_1.default.nextTick(function () {
        return _this.task.cancel();
      });
      this.canceled = true;

      if (this.cancelPromise) {
        AsyncScheduler_1.default.nextTick(function () {
          return _this.cancelPromise(new Error("canceling ".concat(_this.name())));
        });
      }
    }
  }, {
    key: "logDependencies",
    value: function logDependencies() {
      if (this.logger.getLogLevel() > LogLevel_1.default.INFO) {
        return;
      }

      if (!this.dependencies) {
        return;
      }

      var names = this.dependencies.filter(function (d) {
        return d;
      }).map(function (d) {
        return d.name();
      }).join(', ');
      this.logger.info("".concat(this.task.name(), " waiting for dependencies: ").concat(names));
    }
  }, {
    key: "run",
    value: function run() {
      var _this2 = this;

      if (this.promise) {
        return this.promise;
      }

      var dependencies = this.dependencies ? Promise.all(this.dependencies.map(function (d) {
        return d === null || d === void 0 ? void 0 : d.run();
      })) : Promise.resolve();
      this.logDependencies();
      this.ongoing = dependencies.then(function () {
        return _this2.task.run();
      });
      return this.promise = new Promise(function (resolve, reject) {
        _this2.cancelPromise = reject;

        _this2.ongoing.then(resolve).catch(reject);
      });
    }
  }, {
    key: "setParent",
    value: function setParent(parentTask) {
      this.task.setParent(parentTask);
    }
  }]);

  return OnceTask;
}();

exports.default = OnceTask;